export default "__VITE_ASSET__p2WFfhL8__"